import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { V1SignInComponent } from './pages/v1-sign-in/v1-sign-in.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';

import { AuthenticationValidationService } from './modules/shared/services/authentication-validation.service';
import { LogoutComponent } from './pages/logout/logout.component';
import { ErrorComponent } from './pages/error/error.component';
import { NotificationMG1Component } from './modules/shared/components/notification-mg1/notification-mg1.component';
import { EditProfileComponent } from './modules/shared/components/edit-profile/edit-profile.component';
// import { ShibbolethSignInComponent } from './pages/shibboleth-sign-in/shibboleth-sign-in.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: SignInComponent
  },
  {
    path: 'v1signin',
    pathMatch: 'full',
    component: V1SignInComponent
  },
  {
    path: 'signin',
    pathMatch: 'full',
    component: SignInComponent,
  },
  // {
  //   path: 'logout',
  //   pathMatch: 'full',
  //   component: LogoutComponent
  // },
  {
    path: 'error',
    pathMatch: 'full',
    component: ErrorComponent
  },
  {
    path: 'signup',
    pathMatch: 'full',
    component: SignUpComponent,
    data: { title: '', breadCrumbs: '' }
  },
  {
    path: 'notifications',
    pathMatch: 'full',
    component: NotificationMG1Component
  },
  {
    path: 'profile',
    pathMatch: 'full',
    canActivate: [AuthenticationValidationService],
    component: EditProfileComponent
  },
  {
    path: 'admin-dashboard',
    canActivate: [AuthenticationValidationService],
    loadChildren: './modules/admin-dashboard/admin-dashboard.module#AdminDashboardModule',
    data: { headerHidden: true }
  },
  {
    path: 'bus-operators',
    loadChildren: './modules/bus-operators/bus-operators.module#BusOperatorsModule'
  },
  {
    path: 'buses',
    loadChildren: './modules/bus/bus.module#BusModule'
  },
  {
    path: 'bus-dashboard',
    loadChildren: './modules/bus-dashboard/bus-dashboard.module#BusDashboardModule',
    data: { headerHidden: true }
  },
  {
    path: 'bus-booking',
    loadChildren: './modules/bus-booking/bus-booking.module#BusBookingModule'
  },
  {
    path: 'cancellation-and-refunds',
    loadChildren: './modules/bus-manage-refunds/bus-manage-refunds.module#BusManageRefundsModule'
  },
  {
    path: 'bus-routes',
    loadChildren: './modules/bus-routes/bus-routes.module#BusRoutesModule'
  },
  {
    path: 'bus-manage-schedule',
    loadChildren: './modules/bus-manage-schedule/bus-manage-schedule.module#BusManageScheduleModule'
  },
  {
    path: 'bus-drivers',
    loadChildren: './modules/bus-drivers/bus-drivers.module#BusDriversModule'
  },
  {
    path: 'bus-seat-layouts',
    loadChildren: './modules/bus-seat-layouts/bus-seat-layouts.module#BusSeatLayoutsModule'
  },
  {
    path: 'bus-manage-tours',
    loadChildren: './modules/bus-manage-tour/bus-manage-tour.module#BusManageTourModule'
  },
  {
    path: 'manage-contents',
    loadChildren: './modules/bus-manage-content/bus-manage-content.module#BusManageContentModule'
  },
  {
    path: 'bus-taxes',
    loadChildren: './modules/bus-taxes/bus-taxes.module#BusTaxesModule'
  },
  {
    path: 'drivers',
    canActivate: [AuthenticationValidationService],
    loadChildren: './modules/drivers/drivers.module#DriversModule'
  },
  {
    path: 'vehicles',
    canActivate: [AuthenticationValidationService],
    loadChildren: './modules/vehicles/vehicles.module#VehiclesModule'
  },
  {
    path: 'settings',
    canActivate: [AuthenticationValidationService],
    loadChildren: './modules/settings/settings.module#SettingsModule'
  },
  {
    path: 'notifications',
    canActivate: [AuthenticationValidationService],
    loadChildren: './modules/notifications/notifications.module#NotificationsModule'
  },
  {
    path: 'emergency-request',
    canActivate: [AuthenticationValidationService],
    loadChildren: './modules/emergency-request/emergency-request.module#EmergencyRequestModule'
  },
  {
    path: 'reports',
    canActivate: [AuthenticationValidationService],
    loadChildren: './modules/reports/reports.module#ReportsModule'

  },
  {
    path: 'passengers',
    canActivate: [AuthenticationValidationService],
    loadChildren: './modules/passengers/passengers.module#PassengersModule'

  },
  {
    path: 'user-management',
    canActivate: [AuthenticationValidationService],
    loadChildren: './modules/user-management/user-management.module#UserManagementModule'

  },
  {
    path: 'marketing',
    canActivate: [AuthenticationValidationService],
    loadChildren: './modules/marketing/marketing.module#MarketingModule'
  },
  {
    path: 'admin-chat',
    loadChildren: './modules/admin-chat/admin-chat.module#AdminChatModule'
  },
  {
    path: 'customer-feedbacks',
    loadChildren: './modules/customer-feedback/customer-feedback.module#CustomerFeedbackModule'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
